export default {
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_IS_ALERT: 'SET_IS_ALERT',
    SET_IS_DATA: 'SET_IS_DATA'
};
